var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _rect3, _rect4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect5, _rect6, _path30, _path31, _rect7, _rect8, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _g, _path70, _path71, _path72, _path73, _path74, _g2, _path75, _path76, _path77, _path78, _path79, _g3, _path80, _path81, _path82, _ellipse, _path83, _path84, _path85;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirePlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 310.41 324.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13{fill:#e51f59}.cls-15,.cls-2,.cls-5{fill:#fff}.cls-15,.cls-2,.cls-20,.cls-27,.cls-6{stroke:#1d1d1b}.cls-2,.cls-6{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.61px}.cls-9{fill:#b8bcbf}.cls-6{fill:none}.cls-7{fill:#706f6f}.cls-8{fill:#878787}.cls-11{fill:#ffce9d}.cls-11,.cls-13{opacity:.72}.cls-12{fill:#ffb161}.cls-15,.cls-20,.cls-27{stroke-miterlimit:10}.cls-22{fill:#683c11}.cls-20{fill:#7d4e24}.cls-21{fill:#ca9e67}.cls-23{opacity:.65}.cls-24{fill:#ee7d00}.cls-27{fill:#432918}.cls-28{fill:#ff6a48}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.84 299.38H295a9.88 9.88 0 0 1 9.88 9.88v15.49H4v-15.48a9.88 9.88 0 0 1 9.84-9.89z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.18 113.81h160.85v185.58H77.18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.8 166.44h143.61v132.94H85.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.61 87.15H296.7v5.71A20.14 20.14 0 0 1 276.57 113H31.75a20.14 20.14 0 0 1-20.14-20.13v-5.72h0z",
    style: {
      fill: "#b8bcbf",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.61px",
      stroke: "#1d1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3e3c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.61px",
      stroke: "#1d1d1b"
    },
    d: "M.81 73.33H309.6v12.53H.81z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97 113.81h37.21v185.58H39.97z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.97 113.81h37.21v185.58H39.97z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.07 119.72H37.52a2.73 2.73 0 0 1-2.73-2.72v-3.18h46.93v2.26a3.65 3.65 0 0 1-3.65 3.64z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.07 119.72H37.52a2.73 2.73 0 0 1-2.73-2.72v-3.18h46.93v2.26a3.65 3.65 0 0 1-3.65 3.64z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 34.79,
    y: 133.71,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 34.79,
    y: 133.71,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.44 293.47h42a2.72 2.72 0 0 1 2.72 2.73v3.18H34.79v-2.26a3.65 3.65 0 0 1 3.65-3.65z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.44 293.47h42a2.72 2.72 0 0 1 2.72 2.73v3.18H34.79v-2.26a3.65 3.65 0 0 1 3.65-3.65z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 34.79,
    y: 273.57,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 34.79,
    y: 273.57,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97 155.97h37.21v14.85H39.97z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.97 155.97h37.21v14.85H39.97z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.26 140.37h18.92v14.85H58.26z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.26 140.37h18.92v14.85H58.26z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97 186.41h37.21v14.85H39.97z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.97 186.41h37.21v14.85H39.97z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M58.26 170.81h18.92v14.85H58.26z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.26 170.81h18.92v14.85H58.26z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97 216.85h37.21v14.85H39.97z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.97 216.85h37.21v14.85H39.97z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.26 201.26h18.92v14.85H58.26z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.26 201.26h18.92v14.85H58.26z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.97 247.3h37.21v14.85H39.97z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M39.97 247.3h37.21v14.85H39.97z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.26 231.7h18.92v14.85H58.26z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.26 231.7h18.92v14.85H58.26z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M237.71 113.81h37.21v185.58h-37.21z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.71 113.81h37.21v185.58h-37.21z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.81 119.72h-40.55a2.73 2.73 0 0 1-2.73-2.73v-3.18h46.93v2.26a3.65 3.65 0 0 1-3.65 3.65z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.81 119.72h-40.55a2.73 2.73 0 0 1-2.73-2.73v-3.18h46.93v2.26a3.65 3.65 0 0 1-3.65 3.65z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.53,
    y: 133.71,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 232.53,
    y: 133.71,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M236.18 293.47h42a2.72 2.72 0 0 1 2.72 2.73v3.18h-48.37v-2.26a3.66 3.66 0 0 1 3.65-3.65z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M236.18 293.47h42a2.72 2.72 0 0 1 2.72 2.73v3.18h-48.37v-2.26a3.66 3.66 0 0 1 3.65-3.65z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 232.53,
    y: 273.57,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 232.53,
    y: 273.57,
    width: 46.93,
    height: 5.91,
    rx: 2.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.71 155.97h37.21v14.85h-37.21z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.71 155.97h37.21v14.85h-37.21z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256 140.37h18.92v14.85H256z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256 140.37h18.92v14.85H256z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.71 186.41h37.21v14.85h-37.21z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.71 186.41h37.21v14.85h-37.21z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256 170.81h18.92v14.85H256z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256 170.81h18.92v14.85H256z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.71 216.85h37.21v14.85h-37.21z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.71 216.85h37.21v14.85h-37.21z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256 201.26h18.92v14.85H256z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256 201.26h18.92v14.85H256z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M237.71 247.3h37.21v14.85h-37.21z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.71 247.3h37.21v14.85h-37.21z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M256 231.7h18.92v14.85H256z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256 231.7h18.92v14.85H256z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffdec7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.61px",
      stroke: "#1d1d1b"
    },
    d: "M95.19 188.86h121.54v110.53H95.19z"
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.41 314.56H3.96M232.53 93.12h64.12M11.97 98.61h41.94"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.19 32.79a8.15 8.15 0 0 1-.45 3.84 12.48 12.48 0 0 1-1 1.59 6.75 6.75 0 0 0-1.16 3.23 4.15 4.15 0 0 0 1.09 3.18 3.09 3.09 0 0 1 .77.89c.27.65-.14 1.35-.43 2a3.41 3.41 0 0 0-.18 2.67A1.89 1.89 0 0 0 55 51.33a2.75 2.75 0 0 0 1.46-2.06 27.66 27.66 0 0 0 .74-7.09c0-3.11-.08-6.23-.31-9.33"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.4 67.56H57.1a2.9 2.9 0 0 1-2.9-2.9v-31.5a2.9 2.9 0 0 1 3.44-2.85L72 33a2.9 2.9 0 0 1 2.35 2.85v28.81a2.9 2.9 0 0 1-2.95 2.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72 33-14.36-2.69a2.9 2.9 0 0 0-3.44 2.85v.54a4.77 4.77 0 0 0 2.53 2.18 21.4 21.4 0 0 0 3.81.93 3 3 0 0 1 2 1.07c.72 1.14 0 3.17 1.27 3.67 1 .38 1.83-.74 2.22-1.7s1-2.16 2-2.12c.85 0 1.38.93 2.12 1.36a2.72 2.72 0 0 0 2.76-.21 4.57 4.57 0 0 0 1.41-1.55v-1.45A2.9 2.9 0 0 0 72 33z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M61.53 21.38A12.79 12.79 0 0 0 59.05 25a6 6 0 0 0 2.59 7.15 5.67 5.67 0 0 0 7.27-1.9 7.93 7.93 0 0 0 .68-5.65 15.09 15.09 0 0 0-6.84-10c2.51 2.01.35 4.96-1.22 6.78z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.66 26.1a7.52 7.52 0 0 0-1.45 2.1 3.49 3.49 0 0 0 1.51 4.18A3.32 3.32 0 0 0 67 31.27a4.69 4.69 0 0 0 .4-3.3 8.9 8.9 0 0 0-4-5.83c1.44 1.17.18 2.86-.74 3.96z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M63.38 29.08a4.15 4.15 0 0 0-.8 1.16 1.93 1.93 0 0 0 .83 2.31 1.83 1.83 0 0 0 2.34-.62 2.53 2.53 0 0 0 .25-1.82 4.86 4.86 0 0 0-2.2-3.2c.78.64.08 1.59-.42 2.17z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.62 69.07H28.48A2.28 2.28 0 0 1 26 67V45a2.37 2.37 0 0 1 2.93-2l12.14 1.91a2.18 2.18 0 0 1 2 2V67a2.28 2.28 0 0 1-2.45 2.07z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M32.08 34a12.83 12.83 0 0 0-2.49 3.6 6 6 0 0 0 2.59 7.14 5.67 5.67 0 0 0 7.28-1.9 8 8 0 0 0 .67-5.65 15.14 15.14 0 0 0-6.83-10c2.5 2.08.34 5.02-1.22 6.81z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33.2 38.75a7.78 7.78 0 0 0-1.45 2.11A3.48 3.48 0 0 0 33.27 45a3.31 3.31 0 0 0 4.25-1.11 4.71 4.71 0 0 0 .4-3.31 8.84 8.84 0 0 0-4-5.82c1.46 1.24.2 2.92-.72 3.99z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.92 41.74a4.15 4.15 0 0 0-.8 1.16 1.92 1.92 0 0 0 .88 2.3 1.83 1.83 0 0 0 2.35-.61 2.59 2.59 0 0 0 .21-1.82 4.88 4.88 0 0 0-2.2-3.21c.76.64.06 1.59-.44 2.18z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.95 63.3h67.77v.2a9.22 9.22 0 0 1-9.22 9.22H23.16a9.22 9.22 0 0 1-9.22-9.22v-.2h.01z",
    style: {
      fill: "#2fb6bc"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    transform: "rotate(180 125.795 43.745)",
    d: "M117.03 15.69h17.53v56.1h-17.53z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.03 57.64h17.53v7.86h-17.53zm17.53-29.83h-17.73v5.27h17.73",
    style: {
      fill: "#009657",
      strokeMiterlimit: 10,
      stroke: "#1d1d1b"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    transform: "rotate(180 110.02 50.755)",
    d: "M103.01 29.72h14.02v42.07h-14.02z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    transform: "rotate(180 110.02 39.33)",
    d: "M103.01 36.13h14.02v6.41h-14.02z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M103.01 62.55h14.23"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    transform: "rotate(159.18 170.096 42.89)",
    d: "M161.02 14.58h18.14v56.6h-18.14z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(159.18 165.713 31.354)",
    style: {
      fill: "#004f9e",
      strokeMiterlimit: 10,
      stroke: "#1d1d1b"
    },
    d: "M156.64 29.16h18.14v4.37h-18.14z"
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    transform: "rotate(180 143.325 36.145)",
    d: "M134.56.5h17.53v71.29h-17.53z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeMiterlimit: 10,
      stroke: "#1d1d1b",
      fill: "#e51f59"
    },
    d: "M134.56 9.08h17.53v7.86h-17.53z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.56 42.88h17.53v3.93h-17.53z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128 256.5c-3.69 1.65-6.29 6.23-6.19 11.57s2.87 9.8 6.61 11.31l54.14-.5-.44-24.1z",
    style: {
      fill: "#683c11",
      strokeMiterlimit: 10,
      stroke: "#1d1d1b"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M190.45 266.67c.12 6.65-3.95 12.13-9.09 12.24s-9.41-5.21-9.54-11.86 4-12.14 9.1-12.24 9.41 5.19 9.53 11.86z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M188.7 266.7c.1 5.29-3.13 9.65-7.22 9.73s-7.48-4.14-7.58-9.43 3.14-9.65 7.23-9.73 7.48 4.14 7.57 9.43z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M185.51 266.77c.05 2.9-1.72 5.29-4 5.33s-4.1-2.27-4.16-5.17 1.72-5.29 4-5.33 4.11 2.27 4.16 5.17z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M182.33 261.31a4.24 4.24 0 0 1 2.22 1.51 6.48 6.48 0 0 1 1.35 3.94 6.52 6.52 0 0 1-1.21 4 3.83 3.83 0 0 1-6.34.13 6.84 6.84 0 0 1-.14-7.94 3.75 3.75 0 0 1 4.12-1.64zm2.79 5.47a5.63 5.63 0 0 0-1.16-3.44 3.08 3.08 0 0 0-5.14.11 5.59 5.59 0 0 0-1 3.48 5.64 5.64 0 0 0 1.16 3.43 3.08 3.08 0 0 0 5.15-.1 5.66 5.66 0 0 0 1-3.48z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M170.25 273.67a.38.38 0 0 1 .28.32.4.4 0 0 1-.31.47 25.76 25.76 0 0 1-7 .05 30 30 0 0 0-5.52-.14 15.57 15.57 0 0 0-6.41 2.08 4.2 4.2 0 0 0-1.69 1.55.37.37 0 0 1-.52.17.42.42 0 0 1-.16-.55 4.84 4.84 0 0 1 2-1.88 16.28 16.28 0 0 1 6.72-2.18 31.32 31.32 0 0 1 5.65.14 25.08 25.08 0 0 0 6.76 0 .32.32 0 0 1 .2-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M162.11 275.87a5 5 0 0 1 .74.26.42.42 0 0 1 .21.53.38.38 0 0 1-.51.22 4.69 4.69 0 0 0-5.32 1.22.38.38 0 0 1-.55 0 .41.41 0 0 1 0-.57 5.51 5.51 0 0 1 5.43-1.66zm6.94-13.07a.38.38 0 0 1 .28.27.42.42 0 0 1-.26.51c-1.57.49-3.52 1.1-5.37.63a9.72 9.72 0 0 1-2.65-1.28 16.69 16.69 0 0 0-1.65-.91c-2.3-1-4.94-.67-7.49-.34l-1.58.19c-2.94.32-6.88.09-8.92-2.82a.41.41 0 0 1 .08-.56.37.37 0 0 1 .54.08c1.82 2.6 5.48 2.79 8.23 2.49.51-.05 1-.12 1.56-.19 2.65-.34 5.38-.7 7.88.4a14.46 14.46 0 0 1 1.73 1 9.39 9.39 0 0 0 2.43 1.18 9.32 9.32 0 0 0 5-.62.34.34 0 0 1 .19-.03zm-17.63-6.94a.38.38 0 0 1 .23.16.42.42 0 0 1-.11.57 5.8 5.8 0 0 1-5.81.47.41.41 0 0 1-.19-.54.38.38 0 0 1 .51-.2 5 5 0 0 0 5.07-.41.36.36 0 0 1 .3-.05zm9.58 11.99a.36.36 0 0 1 .26.22.41.41 0 0 1-.19.54c-2.23 1.07-4.68.65-7.06.23a13.56 13.56 0 0 0-5.83-.19 13.45 13.45 0 0 0-4 2.2 24 24 0 0 1-2.45 1.6c-4.28 2.29-9.38 1.67-14.24.65-1.38-.29-3.25-.87-3.69-2.56a.4.4 0 0 1 .27-.5.38.38 0 0 1 .47.28c.33 1.27 1.93 1.74 3.1 2 4.73 1 9.66 1.61 13.74-.58a22.87 22.87 0 0 0 2.37-1.54 14.06 14.06 0 0 1 4.23-2.31 13.9 13.9 0 0 1 6.15.17c2.36.41 4.59.8 6.61-.17a.31.31 0 0 1 .26-.04zm-25-4.65a.44.44 0 0 1 .25.2 2.7 2.7 0 0 1-.36 2.81 4.82 4.82 0 0 1-2.17 1.45 11.12 11.12 0 0 1-9.94-1.09.43.43 0 0 1-.13-.56.38.38 0 0 1 .54-.13 10.36 10.36 0 0 0 9.27 1 4 4 0 0 0 1.83-1.21 1.85 1.85 0 0 0 .28-1.89.44.44 0 0 1 .15-.56.4.4 0 0 1 .28-.02zm-5.59-5.45a.24.24 0 0 1 .1.05 3.41 3.41 0 0 1 1.1 4.34 3.08 3.08 0 0 1-4.1 1.27.42.42 0 0 1-.16-.55.37.37 0 0 1 .52-.17 2.32 2.32 0 0 0 3.07-.95 2.6 2.6 0 0 0-.82-3.25.4.4 0 0 1-.14-.55.39.39 0 0 1 .43-.19zm-2.74.91a.34.34 0 0 1 .12.06.41.41 0 0 1 .1.56 4.31 4.31 0 0 1-3.33 2 .39.39 0 0 1-.4-.38.4.4 0 0 1 .36-.43 3.5 3.5 0 0 0 2.73-1.61.39.39 0 0 1 .42-.2zm6.33 17.91a5.83 5.83 0 0 1 .71.22.41.41 0 0 1 .25.51.4.4 0 0 1-.49.26 8.4 8.4 0 0 0-5.13-.14.37.37 0 0 1-.47-.28.4.4 0 0 1 .26-.5 9.05 9.05 0 0 1 4.87-.07zm38.05-19.17a.4.4 0 0 1 .29.34.41.41 0 0 1-.33.46 13.59 13.59 0 0 1-8.74-1.69.4.4 0 0 1-.15-.55.37.37 0 0 1 .52-.16 12.85 12.85 0 0 0 8.26 1.59.38.38 0 0 1 .15.01z"
  }))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M142 302.77c-3.74-1.52-6.49-6-6.56-11.34s2.56-9.9 6.25-11.54l54.13-1.4.32 24.1z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M204.14 290.42c-.09-6.66-4.33-12-9.47-11.92s-9.25 5.54-9.16 12.19 4.33 12 9.47 11.91 9.25-5.53 9.16-12.18z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M202.39 290.44c-.07-5.29-3.44-9.53-7.53-9.47s-7.34 4.4-7.27 9.69 3.44 9.53 7.53 9.47 7.34-4.4 7.27-9.69z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M199.2 290.49c0-2.9-1.89-5.23-4.13-5.19s-4 2.41-4 5.31 1.89 5.23 4.13 5.19 4.04-2.41 4-5.31z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M195.21 296.21a4 4 0 0 1-3.19-1.64 6.8 6.8 0 0 1-.1-7.94 3.82 3.82 0 0 1 6.34-.1 6.53 6.53 0 0 1 1.32 4 6.48 6.48 0 0 1-1.22 4 4.31 4.31 0 0 1-2.17 1.59 3.93 3.93 0 0 1-.98.09zm3.6-5.71a5.65 5.65 0 0 0-1.15-3.45 3.07 3.07 0 0 0-5.14.08 6 6 0 0 0 .09 6.92 3.07 3.07 0 0 0 5.14-.08 5.63 5.63 0 0 0 1.06-3.47z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M183.72 284.13a.39.39 0 0 0 .28-.33.4.4 0 0 0-.32-.46 25.8 25.8 0 0 0-7 .19 30.85 30.85 0 0 1-5.51.34 15.42 15.42 0 0 1-6.47-1.86 4 4 0 0 1-1.73-1.49.38.38 0 0 0-.53-.15.41.41 0 0 0-.14.56 4.74 4.74 0 0 0 2 1.8 16.3 16.3 0 0 0 6.79 1.95 32.13 32.13 0 0 0 5.64-.34 25.13 25.13 0 0 1 6.76-.2.29.29 0 0 0 .23-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M175.52 282.21a5.1 5.1 0 0 0 .74-.28.42.42 0 0 0 .19-.54.38.38 0 0 0-.52-.2 4.69 4.69 0 0 1-5.36-1 .38.38 0 0 0-.55 0 .42.42 0 0 0 0 .57 5.49 5.49 0 0 0 5.5 1.45zm7.36 12.79a.4.4 0 0 0 .26-.29.41.41 0 0 0-.27-.5c-1.58-.43-3.55-1-5.39-.43a9.38 9.38 0 0 0-2.61 1.36 13.34 13.34 0 0 1-1.62 1c-2.27 1.1-4.91.85-7.47.6l-1.58-.13c-3-.22-6.89.15-8.84 3.13a.42.42 0 0 0 .1.56.38.38 0 0 0 .54-.1c1.74-2.66 5.39-3 8.14-2.78l1.57.13c2.66.25 5.41.51 7.86-.67a15.43 15.43 0 0 0 1.71-1 9.52 9.52 0 0 1 2.39-1.27c1.63-.49 3.41 0 5 .44a.38.38 0 0 0 .21-.05zm-17.4 7.59a.47.47 0 0 0 .22-.18.43.43 0 0 0-.13-.56 5.84 5.84 0 0 0-5.83-.26.43.43 0 0 0-.17.55.38.38 0 0 0 .52.17 5.05 5.05 0 0 1 5.08.24.37.37 0 0 0 .31.04zm9.15-12.32a.38.38 0 0 0 .25-.23.41.41 0 0 0-.21-.53c-2.26-1-4.7-.48-7.06 0a13.44 13.44 0 0 1-5.82.38 13.06 13.06 0 0 1-4.06-2.05 23.37 23.37 0 0 0-2.5-1.51c-4.35-2.14-9.42-1.34-14.25-.15-1.37.33-3.22 1-3.61 2.69a.4.4 0 0 0 .29.48.38.38 0 0 0 .46-.3c.29-1.27 1.87-1.8 3-2.08 4.7-1.16 9.61-1.94 13.75.1a23.82 23.82 0 0 1 2.42 1.45 14 14 0 0 0 4.3 2.17 14.05 14.05 0 0 0 6.14-.39c2.35-.49 4.57-1 6.62-.06a.36.36 0 0 0 .28.03zm-24.83 5.52a.38.38 0 0 0 .24-.21 2.66 2.66 0 0 0-.45-2.79 4.91 4.91 0 0 0-2.21-1.38 11.18 11.18 0 0 0-9.91 1.44.43.43 0 0 0-.1.57.38.38 0 0 0 .53.11 10.39 10.39 0 0 1 9.24-1.35 4 4 0 0 1 1.86 1.15 1.84 1.84 0 0 1 .35 1.88.42.42 0 0 0 .17.55.35.35 0 0 0 .28.03zm-5.39 5.64h.1a3.45 3.45 0 0 0 1-4.39 3.07 3.07 0 0 0-4.14-1.12.42.42 0 0 0-.15.55.38.38 0 0 0 .53.16 2.32 2.32 0 0 1 3.1.83 2.61 2.61 0 0 1-.72 3.28.42.42 0 0 0-.12.56.37.37 0 0 0 .4.13zm-2.77-.81a.27.27 0 0 0 .12-.06.42.42 0 0 0 .09-.57 4.32 4.32 0 0 0-3.39-1.84.38.38 0 0 0-.39.4.39.39 0 0 0 .38.41 3.56 3.56 0 0 1 2.78 1.51.36.36 0 0 0 .41.15zm5.74-18.12c.24-.07.48-.15.71-.24a.42.42 0 0 0 .23-.52.39.39 0 0 0-.5-.24 8.31 8.31 0 0 1-5.12.31.38.38 0 0 0-.46.3.4.4 0 0 0 .28.49 9 9 0 0 0 4.86-.1zM186 300.33a.41.41 0 0 0-.06-.8 13.61 13.61 0 0 0-8.69 2 .43.43 0 0 0-.13.56.37.37 0 0 0 .53.14 12.85 12.85 0 0 1 8.2-1.88.38.38 0 0 0 .15-.02z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M116.6 302.57c-3.73-1.55-6.45-6-6.5-11.38s2.61-9.89 6.31-11.51l54.13-1.11.21 24.1z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M178.79 290.54c0-6.65-4.27-12-9.41-12s-9.27 5.48-9.21 12.14 4.27 12 9.41 12 9.27-5.48 9.21-12.14z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M177.05 290.56c-.05-5.29-3.4-9.55-7.49-9.51s-7.36 4.36-7.32 9.65 3.4 9.55 7.49 9.51 7.36-4.36 7.32-9.65z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M173.85 290.59c0-2.9-1.86-5.24-4.1-5.22s-4 2.39-4 5.3 1.87 5.23 4.11 5.21 4.02-2.39 3.99-5.29z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M169.84 296.29a4 4 0 0 1-3.18-1.66 6.82 6.82 0 0 1-.07-7.94 3.82 3.82 0 0 1 6.34-.06 6.47 6.47 0 0 1 1.31 4 6.55 6.55 0 0 1-1.24 4 4.25 4.25 0 0 1-2.18 1.57 3.93 3.93 0 0 1-.98.09zm3.63-5.7a5.61 5.61 0 0 0-1.13-3.44 3.08 3.08 0 0 0-5.15 0 5.7 5.7 0 0 0-1.07 3.47 5.64 5.64 0 0 0 1.13 3.45 3.08 3.08 0 0 0 5.14-.05 5.65 5.65 0 0 0 1.08-3.47z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M150.22 282.19a5.16 5.16 0 0 0 .74-.29.42.42 0 0 0 .19-.53.38.38 0 0 0-.51-.21 4.69 4.69 0 0 1-5.36-1.05.38.38 0 0 0-.55 0 .43.43 0 0 0 0 .57 5.51 5.51 0 0 0 5.49 1.51zm-10.15 20.32a.38.38 0 0 0 .23-.17.42.42 0 0 0-.12-.56 5.82 5.82 0 0 0-5.83-.3.43.43 0 0 0-.18.55.39.39 0 0 0 .52.18 5 5 0 0 1 5.08.26.35.35 0 0 0 .3.04zm-15.64-6.88a.38.38 0 0 0 .24-.21 2.66 2.66 0 0 0-.44-2.79 4.77 4.77 0 0 0-2.2-1.39 11.11 11.11 0 0 0-9.91 1.39.41.41 0 0 0-.11.56.38.38 0 0 0 .54.11 10.37 10.37 0 0 1 9.24-1.29 4 4 0 0 1 1.86 1.15 1.87 1.87 0 0 1 .34 1.89.42.42 0 0 0 .16.55.45.45 0 0 0 .28.03zm-5.43 5.61h.1a3.44 3.44 0 0 0 1-4.38 3.07 3.07 0 0 0-4.13-1.15.43.43 0 0 0-.15.56.38.38 0 0 0 .53.15 2.32 2.32 0 0 1 3.09.86 2.6 2.6 0 0 1-.73 3.27.41.41 0 0 0-.12.56.38.38 0 0 0 .41.13zm-2.75-.82a.27.27 0 0 0 .12-.06.42.42 0 0 0 .09-.57 4.28 4.28 0 0 0-3.38-1.86.39.39 0 0 0-.4.39.41.41 0 0 0 .38.42 3.51 3.51 0 0 1 2.77 1.53.39.39 0 0 0 .42.15zm44.4-.06a.41.41 0 0 0-.06-.8 13.65 13.65 0 0 0-8.69 1.94.42.42 0 0 0-.14.56.39.39 0 0 0 .53.15 12.8 12.8 0 0 1 8.21-1.84z"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M107.39 268.13a1.07 1.07 0 1 1-1.07-1.09 1.08 1.08 0 0 1 1.07 1.09z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M208 230.1a2.28 2.28 0 1 1-2.28-2.32 2.3 2.3 0 0 1 2.28 2.32z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M106.2 264.74a.63.63 0 1 1-.63-.64.64.64 0 0 1 .63.64zm104.07-39.85a1.17 1.17 0 1 1-1.16-1 1.09 1.09 0 0 1 1.16 1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.86 262.82a1.54 1.54 0 1 1-1.54-1.61 1.58 1.58 0 0 1 1.54 1.61zm-80.59-53.72a1.54 1.54 0 1 1-1.53-1.62 1.57 1.57 0 0 1 1.53 1.62z",
    style: {
      fill: "#ff4600"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 209.5,
    cy: 253.37,
    rx: 0.77,
    ry: 0.81
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.43 202a.78.78 0 0 1-.76.81.81.81 0 0 1 0-1.61.78.78 0 0 1 .76.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.72 239.07a.77.77 0 1 1-.77-.81.79.79 0 0 1 .77.81zm-.72 27.06a.5.5 0 1 1-.5-.53.51.51 0 0 1 .5.53zm12.5-50.58a.77.77 0 1 1-.76-.8.78.78 0 0 1 .76.8z",
    style: {
      fill: "#ffc680"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M128.58 209.1a.77.77 0 1 1-.76-.81.78.78 0 0 1 .76.81z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.56 33.08v-5.27"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirePlace);
export default __webpack_public_path__ + "static/media/firePlace.3ab803bae1c159755d3d911662b8e977.svg";
export { ForwardRef as ReactComponent };